define.alias("shared/components/shared/button/boost", "settings/components/shared/button/boost");